import gql from 'graphql-tag';

export default gql`
mutation deleteReport($obj: DeleteReportInput!) {
  deleteReport(object: $obj) {
    deletedReport
  }
}
`;
